<template>
    <div class="page honor-panel-page">
        <transition name="fade-transition">
            <v-container v-if="!loading" :class="{'py-3 px-0': phoneOnly, 'py-6': pcOnly}">
                <honor-board-list
                    v-if="rankedStudents.length"
                    :students="rankedStudents"
                    :exam-name="examName"
                    :count-label="rankedStudents.length + ' طالب'"
                    :padded="phoneOnly"
                    :highlight-top="true"
                />
                <div v-else class="honor-panel-page__empty text-center py-12 px-4">
                    <div class="honor-panel-page__empty-icon mb-3">
                        <v-icon size="40" color="white">mdi-trophy-outline</v-icon>
                    </div>
                    <div class="medium-text font-weight-bold strong-text--text mb-1">لوحة الشرف فارغة حالياً</div>
                    <div class="details-text muted--text">لما تظهر نتائج الامتحانات، هتشوف أفضل الطلاب هنا.</div>
                </div>
            </v-container>
        </transition>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import { getHonorExamName, rankHonorStudents } from '@/helpers/honor-board'
import HonorBoardList from '@/components/custom/honor-board-list'

export default {
    name: 'HonorPanel',
    components: {
        HonorBoardList,
    },
    data() {
        return {
            honorPanel: null,
            examName: null,
            loading: false,
        }
    },
    computed: {
        rankedStudents() {
            return rankHonorStudents(this.honorPanel || []);
        },
        ...GlobalComputed,
    },
    watch: {
        loading(loading) {
            this.setLinearLoading(loading);
        },
    },
    methods: {
        ...GlobalMethods,
        getHonorPanel() {
            if (!this.loading) {
                this.loading = true;
                this.$store.dispatch('fastGetAction', { url: '/honor-panel' }).then(response => {
                    this.loading = false;
                    const data = response.data || {};
                    this.honorPanel = data.honor_panel || [];
                    this.examName = getHonorExamName(data, this.honorPanel);
                }).catch(() => {
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات');
                    this.loading = false;
                });
            }
        },
    },
    mounted() {
        const place = this.appData.honor_panel_place;
        if (!place || place === 'home' || place === 'separated') {
            this.getHonorPanel();
        } else {
            this.$router.push('/not-found');
        }
    },
};
</script>

<style lang="scss" scoped>
.honor-panel-page__empty-icon {
    width: 4.25rem;
    height: 4.25rem;
    margin-inline: auto;
    border-radius: 1.1rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(145deg, #e53935, #b71c1c);
    box-shadow: 0 12px 28px rgba(229, 57, 53, 0.25);
}
</style>
